var moment = require("moment");
import qs from "qs";
import { mapState } from "vuex";
export default {
    computed: {
        ...mapState(["icons"]),
    },
    data() {
        return {
            _toast: { message: "loading..", forbidClick: true, overlay: true, duration: 0, },
        }
    },
    methods: {
        gMsgbox(msg, title = "") { //彈出訊息
            // return this.$dialog.alert({
            //     title: title,
            //     message: msg,
            //     // theme: 'round-button',

            // });
            return this.$dialog.alert({
                title: title,
                message: msg,
                // theme: 'round-button',

            });
        },
        gSure(msg, title = "") { //彈出對話框，可以選"確認","取消"
            return this.$dialog.confirm({
                title: title,
                message: msg,
                // theme: 'round-button',
            });
        },
        gShowLoading() { //載入轉圈圈
            this.$toast.loading({
                message: "loading..",
                forbidClick: true,
                overlay: true,
                duration: 0,
            });
        },
        gClearLoading() { // 清除loading
            this.$toast.clear();
        },
        gMsg(text, type = "success") { //輕提示3秒，會自動關閉
            // type= "success" , "warning" , "error" 
            this.$message({
                showClose: true,
                message: text,
                type: type,
                customClass: "{background-color:red}",
                allowHtml: true,
            });
            console.log(type, text);
            // this.$toast({
            //     message: '顶部展示',
            //     position: 'top',
            // });
        },
        gNl2br(text) {
            text = text.toString();
            return text.replaceAll("\n", "<br/>");
        },
        gGetIcon(text) {
            if (text == undefined) {
                return "";
            }
            text = text.replaceAll("[spicy]", this.icons.spicy);
            text = text.replaceAll("[vegetable]", this.icons.vegetable);
            text = text.replaceAll("[popular]", this.icons.popular);
            text = text.replaceAll("[star]", this.icons.star);
            text = text.replaceAll("[good]", this.icons.good);
            text = text.replaceAll("[icon1]", this.icons.icon1);
            text = text.replaceAll("[icon2]", this.icons.icon2);
            text = text.replaceAll("[icon3]", this.icons.icon3);
            text = text.replaceAll("[icon4]", this.icons.icon4);
            text = text.replaceAll("[icon5]", this.icons.icon5);
            text = text.replaceAll("[icon6]", this.icons.icon6);
            text = text.replaceAll("[icon7]", this.icons.icon7);
            text = text.replaceAll("[icon8]", this.icons.icon8);
            text = text.replaceAll("[icon9]", this.icons.icon9);
            text = text.replaceAll("[icon10]", this.icons.icon10);
            text = text.replaceAll("[icon11]", this.icons.icon11);
            text = text.replaceAll("[icon12]", this.icons.icon12);
            text = text.replaceAll("[icon13]", this.icons.icon13);
            text = text.replaceAll("[icon14]", this.icons.icon14);
            text = text.replaceAll("[icon15]", this.icons.icon15);
            text = text.replaceAll("[icon16]", this.icons.icon16);
            text = text.replaceAll("[icon17]", this.icons.icon17);
            text = text.replaceAll("[icon18]", this.icons.icon18);
            text = text.replaceAll("[icon19]", this.icons.icon19);
            text = text.replaceAll("[icon20]", this.icons.icon20);
            text = text.replaceAll("[icon21]", this.icons.icon21);
            text = text.replaceAll("[icon22]", this.icons.icon22);
            text = text.replaceAll("[icon23]", this.icons.icon23);
            text = text.replaceAll("[icon24]", this.icons.icon24);
            text = text.replaceAll("[icon25]", this.icons.icon25);
            text = text.replaceAll("[icon26]", this.icons.icon26);
            text = text.replaceAll("[icon27]", this.icons.icon27);
            text = text.replaceAll("[icon28]", this.icons.icon28);
            text = text.replaceAll("[icon29]", this.icons.icon29);
            text = text.replaceAll("[icon30]", this.icons.icon30);
            text = text.replaceAll("[icon31]", this.icons.icon31);
            text = text.replaceAll("[icon32]", this.icons.icon32);
            text = text.replaceAll("[icon33]", this.icons.icon33);
            text = text.replaceAll("[icon34]", this.icons.icon34);
            text = text.replaceAll("[icon35]", this.icons.icon35);
            text = text.replaceAll("[icon36]", this.icons.icon36);
            text = text.replaceAll("[icon37]", this.icons.icon37);
            text = text.replaceAll("[icon38]", this.icons.icon38);
            text = text.replaceAll("[icon39]", this.icons.icon39);
            text = text.replaceAll("[icon40]", this.icons.icon40);
            return text;
        },
        gPushWithUrlQuery(path) {
            var query = this.$route.query;
            this.$router.push({ path: path, query: query });
        },
        sumJson(jsonArray, key) {
            if (jsonArray == undefined) { return ""; }
            if (key == undefined) { return ""; }
            if (jsonArray.length == 0) { return 0; }
            return jsonArray.map(r => r[key]).reduce((sum, qty) => sum + qty);
        },
        gSum(array, key) {
            if (array == undefined) { return ""; }
            if (key == undefined) { return ""; }
            if (array.length == 0) { return 0; }
            // return array.map(r => Number(r[key])).reduce((tmp, qty) => tmp + qty);
            var sum = 0;
            array.map(r => sum += Number(r[key]));
            return sum;
        },
        gpSum(array, key) {
            return new Promise((resolve) => {
                if (array == undefined) { resolve(""); }
                if (key == undefined) { resolve(""); }
                if (array.length == 0) { resolve(0); }
                // return array.map(r => Number(r[key])).reduce((tmp, qty) => tmp + qty);
                var sum = 0;
                array.map(r => sum += Number(r[key]));
                resolve(sum);
            })

        },
        gStr(value) {
            try {
                if (value == undefined) { return ""; }
                if (value == null) { return ""; }
                return value.toString().trim();
            } catch (error) {
                return "";
            }
        },
        quot(value, len = 0) {
            if (len > 0) { value = value.substring(0, len) }
            return "'" + this.str(value) + "'";
        },
        quotes(value, len = 0) {
            if (len > 0) { value = value.substring(0, len) }
            return '"' + this.str(value) + '"';
        },
        val(value) {
            var result = Number(value);
            isNaN(result) && (result = 0);
            return result;
        },
        today() {
            // return this.$moment().format("YYYY-MM-DD");
            return moment().format("YYYY-MM-DD");
        },
        now() {
            return moment().format("YYYY-MM-DD HH:mm:ss");
        },
        hhmm() {
            return moment().format("HHmm");
        },
        ymd() {
            return moment().format("YYYYMMDD");
        },
        weekday() {
            return moment().weekday();
        },
        monthRange(date = this.today()) {
            date = moment(date);
            return { dateb: date.clone().startOf('month').format('YYYY-MM-DD'), datee: date.clone().endOf('month').format('YYYY-MM-DD') };
        },
        gReplace(value, find, replace) {
            return value.replace(RegExp(find, "g"), replace);
        },
        gQS(obj) {
            return qs.stringify(obj);
        },
        gGetItemcRst(obj) { //菜式物件 -> 陣列 (陣列[0]=主餐);
            var item = JSON.parse(JSON.stringify(obj)); // 轉字串再轉回來 避免影響到byval 傳入的物件

            var next = item.Next;
            if (next != undefined) { //處理woosa.下一步
                item.Groups.push(next);
            }
            // console.log("item", item.Groups);
            var data = this.gGetGroups(item);
            return data;
        },
        gGetGroups(obj, data = []) { //將itemc物件轉成陣列
            var groups = obj.Groups;
            if (groups == undefined) {
                return data;
            }
            // console.log("obj", obj);
            data.push(obj);

            for (let i = 0; i < groups.length; i++) {
                var options = groups[i].options;
                options.forEach(item => {
                    this.gGetGroups(item, data); //使用遞迴
                });
            }
            data.map((r) => { r.Groups = undefined });
            return data;
        },
        gGroupBy(data, key) {
            const set = new Set();
            // return data.filter(item => !set.has(item[key]) ? set.add(item[key]) : false);
            var tmp = data.filter(item => !set.has(item[key]) ? set.add(item[key]) : false);
            var array = [];
            tmp.map(r => {
                array.push(r[key]);
            })
            return array;

        }
    },
};